import { useForm } from "react-hook-form";
import Breadcrumbs from "../components/breadcrumbs";
import Header from "../components/header";
import { useAddTicket } from "../hooks/useQueryCart";
import { usePage } from "../hooks/useQueryCustom";
import PageContent from "../components/page-content";
import { Link } from "react-router-dom";

const RegistraBigliettiScuola = ({ page, breadcrumbs }) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({
    defaultValues: {
      barcode: null,
    },
  });
  const { data } = usePage(page.link.slice(1));
  const addTicket = useAddTicket();
  console.log("errors", errors);
  const onSubmit = async (data) => {
    try {
      console.log("payload", data);
      const response = await addTicket.mutateAsync(data);
      console.log("response", response);
    } catch (err) {
      setError("root.serverError", {
        type: err?.code,
      });
      console.error("Error: ", err?.code);
    }
  };

  return (
    <>
      <Header data={breadcrumbs} />
      {breadcrumbs && <Breadcrumbs data={breadcrumbs} />}
      <div role="main" className="main-wrapper  mt-3" id="main">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              <h1>{data?.titoloInPagina}</h1>
            </div>
          </div>
          <div className="bg-gray px-4 py-5 mb-4">
            <div className="row">
              <div className="col-12 col-md-8 offset-md-2">
                <PageContent data={data} />

                <form
                  className="form"
                  name="premium"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <fieldset>
                    <label className="form__label  mb-2">
                      <strong>Barcode*</strong>
                    </label>
                    <input
                      type="hidden"
                      value="pin_pratica"
                      {...register("tipo")}
                    />
                    <input
                      className="form__input mt-1 mb-3"
                      type="text"
                      minLength="13"
                      maxLength="13"
                      {...register("codice", {
                        required: true,
                        pattern: /^[0-9]{13}$/,
                      })}
                    />
                    <label className="form__label">
                      <strong>Nome*</strong>
                    </label>
                    <input
                      className="form__input mt-1 mb-3"
                      type="text"
                      {...register("nome", {
                        required: true,
                      })}
                    />
                    <label className="form__label">
                      <strong>Cognome*</strong>
                    </label>
                    <input
                      className="form__input mt-1 mb-3"
                      type="text"
                      {...register("cognome", {
                        required: true,
                      })}
                    />

                    <label className="form__label mb-3">
                      <strong>Privacy*</strong>
                      <br />
                      <input
                        type="checkbox"
                        className="form__checkbox"
                        {...register("privacy", {
                          required: "Consenso privacy mancante",
                        })}
                      />
                      Dichiaro di aver letto la{" "}
                      <Link
                        to="/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </Link>{" "}
                      del sito.
                    </label>
                    {errors.privacy?.type === "required" && (
                      <p role="alert" className="red my-2">
                        {errors.privacy.message}
                      </p>
                    )}
                    {errors.codice?.type === "required" && (
                      <p role="alert" className="red my-2">
                        Bar code mancante
                      </p>
                    )}
                    {errors.codice?.type === "pattern" && (
                      <p role="alert" className="red my-2">
                        Bar code non valido
                      </p>
                    )}
                    {errors.nome?.type === "required" && (
                      <p role="alert" className="red my-2">
                        Nome mancante
                      </p>
                    )}
                    {errors.cognome?.type === "required" && (
                      <p role="alert" className="red my-2">
                        Cognome mancante
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T4" && (
                      <p role="alert" className="red my-2">
                        Bar code non trovato, non valido o con titoli non ancora
                        consegnati.
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T5" && (
                      <p role="alert" className="red my-2">
                        Pratica non di tipo scuola/gruppo.
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T8" && (
                      <p role="alert" className="red my-2">
                        Bar code non valido
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T9" && (
                      <p role="alert" className="red my-2">
                        Bar Code già inserito nel portafoglio titoli di un altro
                        utente
                      </p>
                    )}
                    {errors?.root?.serverError?.type === "T10" && (
                      <p role="alert" className="red my-2">
                        Bar code già utilizzato
                      </p>
                    )}
                    {(errors?.root?.serverError?.type === "T11" ||
                      errors?.root?.serverError?.type === "T12") && (
                      <p role="alert" className="red my-2">
                        Servizio non disponoibile
                      </p>
                    )}
                    {isSubmitSuccessful && (
                      <p className="red my-2">Codice validato con successo</p>
                    )}
                    <button
                      className="btn btn--link mt-5 m-auto"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting && (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}{" "}
                      Invia
                    </button>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default RegistraBigliettiScuola;
